//
//
//
//
//
//

import Badge from "@Shared/components/general/badge";
import { isBoolean } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ResultsBadge",
  components: {
    Badge
  },
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  computed: {
    badgeFormat() {
      const {
        result
      } = this;
      if ("active" in result && isBoolean(result.active)) return this.getActiveBadge(result);
      if ("applicationStatus" in result) return this.getApplicationStatusBadge(result);
      return {};
    },
    badgeType() {
      return this.badgeFormat && this.badgeFormat.badgeType || "";
    },
    badgeText() {
      return this.badgeFormat && this.badgeFormat.badgeText || "";
    }
  },
  methods: {
    getApplicationStatusBadge({
      applicationStatus
    }) {
      if (!applicationStatus) return;
      const badgeTypeMap = {
        cancelled: "danger",
        pending: "warning",
        submitted: "success"
      };
      const badgeType = badgeTypeMap[applicationStatus] || "primary";
      const badgeText = this.$t("application.status")[applicationStatus];
      return {
        badgeType,
        badgeText
      };
    },
    getActiveBadge({
      active
    }) {
      const badgeType = active ? "success" : "danger";
      const badgeText = active ? this.$t("global.words.active") : this.$t("global.words.inactive");
      return {
        badgeType,
        badgeText
      };
    }
  }
});